import { Theme } from '@material-ui/core';
import { styledBy } from '../../models/AlmeColorMapping';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ palette, spacing }: Theme) {
    return {
        snackBar: {
            position: 'absolute' as const,
            bottom: spacing(1),
            width: '100%',
        },
        snackBarMessage:{width:'80%'},
        snackBarAction:{display:'inline'},
        snackBarContent: {
            color: styledBy('color', {
                default: palette.text.primary,
                divider: palette.text.primary,
                initial: palette.text.primary,
                paper: palette.text.primary,
                primary: palette.primary.contrastText,
                secondary: palette.secondary.contrastText,
            }),
            backgroundColor: styledBy('color', {
                default: palette.background.default,
                divider: palette.divider,
                initial: 'initial',
                paper: palette.background.paper,
                primary: palette.primary.main,
                secondary: palette.secondary.main,
            }),
        },
    };
}